import DotsLoader from '../DotsLoader/DotsLoader'

import styles from './TabsLoading.css'

function TabsLoader() {
  return (
    <div className={styles.loadingTabs}>
      {'Loading tabs'}
      <DotsLoader />
    </div>
  )
}

export default TabsLoader
